import { HttpStatusCodes, IServerResponse } from 'Utilities/ClientResponseUtility';

export async function SitecoreFetch(path: string, options?: {}): Promise<IServerResponse> {
  let data: IServerResponse = { Status: { Code: HttpStatusCodes.InternalServerError, Message: '' }, Data: null };
  if (options === undefined) {
    options = {};
  }
  await fetch(`${path}`, options)
    .then((res) => {
      try {
        data.Status.Code = res.status;
        if (res.status === HttpStatusCodes.OK) {
          return res.json();
        } else return null;
      } catch (error: any) {
        throw new Error('invalid json >> ' + res);
      }
    })
    .then(
      (result) => {
        if (result !== null && result !== undefined) {
          let jsonData: IServerResponse;
          jsonData = parseJSON(result);
          if (jsonData.Status?.Code && jsonData.Status.Code === HttpStatusCodes.Forbidden) {
            data = { Status: { Code: HttpStatusCodes.Forbidden, Message: '' }, Data: null };
          } else data.Data = jsonData;
        }
      },
      (error) => {
        console.error(`${path} >> ${error}`);
        data = { Status: { Code: HttpStatusCodes.InternalServerError, Message: '' }, Data: null };
      },
    )
    .catch((error: any) => {
      console.error(error);
    });
  return data;
}

function parseJSON(str: string) {
  try {
    let json = JSON.parse(str);
    return json;
  } catch (e) {
    return str;
  }
}
